import { render } from "./RelatoryIcon.vue?vue&type=template&id=61e89e16&ts=true"
import script from "./RelatoryIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./RelatoryIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/RelatoryIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61e89e16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61e89e16', __exports__)) {
    api.reload('61e89e16', __exports__)
  }
  
  module.hot.accept("./RelatoryIcon.vue?vue&type=template&id=61e89e16&ts=true", () => {
    api.rerender('61e89e16', render)
  })

}


export default __exports__